import { Caracteristica_proyecto } from './../../../models/caracteristica_proyecto.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { UserService } from 'src/app/services/user.service';
import { MatDialog } from '@angular/material';


declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-caracteristica_proyecto",
    templateUrl: "./caracteristica_proyecto.component.html",
    providers: [FormService, UserService]
})

export class Caracteristica_proyectoComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public caracteristica_proyecto: Caracteristica_proyecto;
    public form;
    public temp_cproy;
    public matcher = new FormService();
    public n_form;
    constructor(private fb: FormBuilder, private _userService: UserService,
        private dialog: MatDialog) {


        this.form = new FormGroup({
            destino: new FormControl(''),
            supertotal: new FormControl(''),
            npisos: new FormControl(''),
            modradio: new FormControl(''),
            usoradio: new FormControl('')
        })

        if (!JSON.parse(localStorage.getItem("caracteristica_proyecto"))) {
            localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("caracteristica_proyecto"));



        }
        this.caracteristica_proyecto = { destino: '', supertotal: '', npisos: '', modradio: '', usoradio: '' };
        this.temp_cproy = { destino: '', supertotal: '', npisos: '', modradio: '', usoradio: '' };

        this.n_form = localStorage.getItem('form');
        console.log("Formulario seleccionado", this.n_form)

    }


    add_caracteristica_proyecto() {
        this.actualRow = localStorage.getItem("caracteristica_proyecto");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.destino && !this.form.value.supertotal && !this.form.value.npisos && !this.form.value.modradio && !this.form.value.usoradio) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);

        } else {
            this.rows = this.rows.concat({
                destino: this.form.value.destino,
                supertotal: this.form.value.supertotal,
                npisos: this.form.value.npisos,
                modradio: this.form.value.modradio,
                usoradio: this.form.value.usoradio

            })
            localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
            this.form.reset();
        }

    }
    delete_caracteristica_proyecto(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("caracteristica_proyecto");
        this.rows = JSON.parse(this.actualRow);
    }

    get_caracteristica_proyecto(id) {
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_cproy.numcaract = id;
                this.temp_cproy.destino = this.rows[x].destino;
                this.temp_cproy.supertotal = this.rows[x].supertotal;
                this.temp_cproy.npisos = this.rows[x].npisos;
                this.temp_cproy.modradio = this.rows[x].modradio;
                this.temp_cproy.usoradio = this.rows[x].usoradio;


                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_cproy = { destino: '', supertotal: '', modradio: '', usoradio: '' };

    }

    save_caracteristica_proyecto() {
        var id = this.temp_cproy.numcaract;
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));

                $("#cproy_modal").modal("hide");
                this.actualRow = localStorage.getItem("caracteristica_proyecto");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    destino: this.temp_cproy.destino,
                    supertotal: this.temp_cproy.supertotal,
                    npisos: this.temp_cproy.npisos,
                    modradio: this.temp_cproy.modradio,
                    usoradio: this.temp_cproy.usoradio,

                })
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(this.rows));
                this.temp_cproy = { destino: '', supertotal: '', npisos: '', modradio: '', usoradio: '' };
                this.dialog.closeAll();
            }
        }
    }


}